<template>
  <div class="libox">
    <ul v-for="(item, i) in dataList" :key="i">
      <li @click="checkDetail(item)">
        <div class="content">
          <p>{{ item.title }}</p>
          <p>{{ formatToDate(item.publishDate) }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { formatToDate } from '@/utils/dateUtils';
import router from '@/router';

const props = defineProps({
  dataList: {
    type: Array,
    default: () => {}
  }
})

// 查看文章
const checkDetail = (item: any) => {
  // sessionStorage.setItem('articleDetail', item);
  router.push({
    path: '/article',
    query: {
      id: item.id
    }
  })
}
</script>

<style lang="scss" scoped>
  .libox {
    width: 100%;

    // background-color: aquamarine;
    // 每篇文章是一个ul
    ul {
      list-style-type: disc; /* 修改为方块 */
      margin-bottom: 15px;
      li {
        text-align: left;
        margin: 10px 0;
        font-size: 15px;

        .content {
          display: flex;
          flex-direction: row;
          justify-content: space-between;

          p:first-child {
            width: 80%;
            overflow: hidden; /* 确保超出容器的文本被隐藏 */
            white-space: nowrap; /* 防止文本换行 */
            text-overflow: ellipsis; /* 超出部分显示省略号 */
            color: #212121;
          }
          p:last-child {
          font-size: 14px;
          color: #888;
          flex-shrink: 0; // 防止日期被压缩
          white-space: nowrap; // 日期也禁止换行
        }
        }
      }
    }
    ul>li:hover {
      // color: #409eff;
      cursor: pointer;
      .content p:first-child,
      .content p:last-child {
        color: #409eff;
        font-weight: bold;
      }

    }
  }
</style>